import loyaltyService from '../Loyalty/loyaltyService';
import api, { httpService } from '../services/api';

const CREDIT_STATE_URL = '/creditAccounts/v2/creditState';

const service = {
    login,
    register,
    getRegistrationOptions,
    getUser,
    updateContactInfo,
    getNeedsPrintFilesItems,
    getNeedsReviewItems,
    getRequiresActionItems,
    resolveRequiresActionItem,
    getCreditState,
};

export default service;

function login (data) {
    return api({
        url: '/users/v2/login',
        method: 'POST',
        data,
    });
}

function register (data) {
    return api({
        url: '/users/v2/registration',
        method: 'POST',
        data,
    });
}

/*
 * Updates the current user's own contact details. Checkout's contact step writes here in addition to
 * patching the project, mirroring order1Controller_rest.js.
 */

function updateContactInfo (data) {
    return api({
        url: '/users/v2/current/registration',
        method: 'POST',
        data,
    });
}

function getRegistrationOptions () {
    return api({
        url: '/users/v2/registration',
        method: 'GET'
    });
}

async function getUser () {
    const user = await api({
        url: '/users/v2/current',
        method: 'GET',
        resolves: [{
            status: 401,
            data: null,
        }],
    });

    if (!user) {
        return user;
    }

    let loyalty = null;

    try {
        loyalty = await loyaltyService.getUserLoyalty(user.id);
    } catch (e) {
        console.error(e);
    }

    return { ...user, loyalty };
}

async function getNeedsPrintFilesItems (userId) {
    const user = userId && { id: userId } || await api({
        url: '/users/v2/current',
        method: 'GET',
        resolves: [{
            status: 401,
            data: null,
        }],
    });

    if (!user) {
        return user;
    }

    const response = await httpService({
        url: '/rest/internal/v1/storefront/jobs/needPrintFiles',
        method: 'GET',
        params: {
            userId: user.id,
            size: 100,
        }
    });

    return response.data.content;
}

async function getNeedsReviewItems (userId) {
    const user = userId && { id: userId } || await api({
        url: '/users/v2/current',
        method: 'GET',
        resolves: [{
            status: 401,
            data: null,
        }],
    });

    if (!user) {
        return user;
    }

    const response = await httpService({
        url: '/rest/internal/v1/storefront/jobs/pendingProofReview',
        method: 'GET',
        params: {
            userId: user.id,
            size: 100,
        }
    });

    return response.data.content;
}

async function getRequiresActionItems (userId) {
    const user = userId && { id: userId } || await api({
        url: '/users/v2/current',
        method: 'GET',
        resolves: [{
            status: 401,
            data: null,
        }],
    });

    if (!user) {
        return user;
    }

    const response = await httpService({
        url: '/rest/internal/v1/storefront/orderLogEntries/needAction',
        method: 'GET',
        params: {
            userId: user.id,
            size: 100,
        }
    });

    return response.data.content;
}

async function resolveRequiresActionItem (userId, itemId) {
    const user = userId && { id: userId } || await api({
        url: '/users/v2/current',
        method: 'GET',
        resolves: [{
            status: 401,
            data: null,
        }],
    });

    if (!user) {
        return user;
    }

    const response = await httpService({
        url: `/rest/internal/v1/storefront/${user.id}/orderLogEntries/${itemId}`,
        method: 'PATCH',
        data: {
            id: itemId,
            resolved: true,
        }
    });

    if (response.data.resolved) {
        return getRequiresActionItems(user.id)
    }

    throw new Error('Could not mark notification as complete. Please try again.')
}

/*
 * The server frames this as "credit state of current user's credit account" - the balance is the
 * shopper's, and projectId is only the context that scopes it: CreditAccountV2Provider resolves
 * accounts against the project's division and returns zero outright when the project does not apply
 * credit. Hence a required project id on what is otherwise a user-level lookup.
 */

function getCreditState (projectId) {
    const requestConfig = {
        url: CREDIT_STATE_URL,
        method: 'GET',
        params: {
            projectId,
        },
        // A user with no credit account is the common case, not an error.
        resolves: [{
            status: 404,
            data: null,
        }],
    };

    return api(requestConfig);
}
